import { Trans, useTranslation } from 'react-i18next';
import FormWithProvider from 'components/forms/form/Form';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import PageHeader from 'components/pageHeader/PageHeader';
import FieldPlaceholder from '../common/FieldPlaceholder';
import usePropertySettingsInitData from '../usePropertySettingsInitData';
import { PropertySettingsDescriptionsTabStyled } from './PropertySettingsDescriptionsTab.styles';
import LabelWithTooltip from './form/LabelWithTooltip';

const FILTERS_PLACEHOLDER_LINE_COUNT = 32 / 14;
const FIELD_PLACEHOLDER_LINE_COUNT_SHORT_SUMMARY = 74 / 14;
const FIELD_PLACEHOLDER_LINE_COUNT_SUMMARY = 134 / 14;
const FIELD_PLACEHOLDER_LINE_COUNT_TEXTAREA = 254 / 14;

const PropertySettingsDescriptionsTabLoader = () => {
  const { t } = useTranslation();
  const { property } = usePropertySettingsInitData();

  return (
    <PropertySettingsDescriptionsTabStyled data-testid="descriptions-loader">
      <PageHeader
        className="tab-title"
        title={
          <Trans
            i18nKey="pageProperty.descriptions.tabTitle"
            values={{ propertyName: property?.name }}
            components={{ 1: <span className="green" /> }}
          />
        }
        noDivider
      />

      <div className="channel-filter-loader">
        <div>
          {t('pageProperty.descriptions.showSupportedDescriptionsPerChannel')}
        </div>
        <LoadingPlaceholder linesCount={FILTERS_PLACEHOLDER_LINE_COUNT} />
      </div>

      <FormWithProvider
        className="placeholder-form"
        defaultValues={{}}
        onSubmit={() => {}}
        noValidate
        disabled
      >
        <FieldPlaceholder
          label={<LabelWithTooltip fieldName="name" />}
          name="name"
          colSmInput={12}
          labelOnTop
          required
        />
        <FieldPlaceholder
          label={<LabelWithTooltip fieldName="shortSummary" />}
          name="shortSummary"
          colSmInput={12}
          linesCount={FIELD_PLACEHOLDER_LINE_COUNT_SHORT_SUMMARY}
          labelOnTop
          required
        />
        <FieldPlaceholder
          label={<LabelWithTooltip fieldName="summary" />}
          name="summary"
          colSmInput={12}
          linesCount={FIELD_PLACEHOLDER_LINE_COUNT_SUMMARY}
          labelOnTop
          required
        />
        <FieldPlaceholder
          label={<LabelWithTooltip fieldName="notes" />}
          name="notes"
          colSmInput={12}
          linesCount={FIELD_PLACEHOLDER_LINE_COUNT_TEXTAREA}
          labelOnTop
        />
        <FieldPlaceholder
          label={<LabelWithTooltip fieldName="interaction" />}
          name="interaction"
          colSmInput={12}
          linesCount={FIELD_PLACEHOLDER_LINE_COUNT_TEXTAREA}
          labelOnTop
        />
        <FieldPlaceholder
          label={<LabelWithTooltip fieldName="neighbourhood" />}
          name="neighbourhood"
          colSmInput={12}
          linesCount={FIELD_PLACEHOLDER_LINE_COUNT_TEXTAREA}
          labelOnTop
        />
        <FieldPlaceholder
          label={<LabelWithTooltip fieldName="access" />}
          name="access"
          colSmInput={12}
          linesCount={FIELD_PLACEHOLDER_LINE_COUNT_TEXTAREA}
          labelOnTop
        />
        <FieldPlaceholder
          label={<LabelWithTooltip fieldName="space" />}
          name="space"
          colSmInput={12}
          linesCount={FIELD_PLACEHOLDER_LINE_COUNT_TEXTAREA}
          labelOnTop
        />
        <FieldPlaceholder
          label={<LabelWithTooltip fieldName="transit" />}
          name="transit"
          colSmInput={12}
          linesCount={FIELD_PLACEHOLDER_LINE_COUNT_TEXTAREA}
          labelOnTop
        />
        <FieldPlaceholder
          label={<LabelWithTooltip fieldName="houseManual" />}
          name="houseManual"
          colSmInput={12}
          linesCount={FIELD_PLACEHOLDER_LINE_COUNT_TEXTAREA}
          labelOnTop
        />
      </FormWithProvider>
    </PropertySettingsDescriptionsTabStyled>
  );
};

export default PropertySettingsDescriptionsTabLoader;
